import {Component, Inject} from '@angular/core';
import {App, ModalController, Platform, NavController, NavParams, ViewController, AlertController} from 'ionic-angular';
import {ROUTER_DIRECTIVES} from '@angular/router';
import {AngularFire, FirebaseRef, FirebaseListObservable, FirebaseObjectObservable} from 'angularfire2';
import * as moment from 'moment';
import {TranslatePipe, TranslateService} from 'ng2-translate/ng2-translate';
import 'rxjs/add/operator/do';


@Component({
  templateUrl: 'build/pages/search/search.html',
  pipes: [TranslatePipe]
})
export class SearchPage {
  trayectos: FirebaseListObservable<any[]>;
  idSalida: number;
  idDestino: string = "";
  gps: FirebaseObjectObservable<any>;
  destinos: FirebaseListObservable<any[]>;
  fecha: string = moment().format("YYYY-MM-DD");
  dayNames: Array<string>;
  monthNames: Array<string>;

  constructor(@Inject(FirebaseRef) public ref:Firebase, public af: AngularFire, public modalCtrl: ModalController, public alertCtrl: AlertController, public translate: TranslateService) {
    this.trayectos = af.database.list('/trayectos');
    this.gps = af.database.object('/gps');
    translate.get("days").subscribe((days: any) => {
      this.dayNames = [days.sun, days.mon, days.tue, days.wed, days.thu, days.fri, days.sat];
    });
    translate.get("months").subscribe((months: any) => {
      this.monthNames = [months.jan, months.feb, months.mar, months.apr, months.may, months.jun, months.jul, months.aug, months.sep, months.oct, months.nov, months.dec];
    });
  }

  onChange(idSalida) {
    this.idSalida = idSalida;
    this.destinos = this.af.database.list('/trayectos/' + idSalida + '/destinos');
    this.idDestino = "";
  }
  
  onSubmit(form) {
    if (form.idSalida && form.idDestino && form.fecha) {
      let data = { 
        'idSalida': form.idSalida,
        'idDestino': form.idDestino,
        'fecha': form.fecha, 
        'desc': form.desc
      };
      let modal = this.modalCtrl.create(SearchDetailPage, data);
      modal.present();
    } else {
      this.translate.get("missing_info").subscribe(value => {
        let alert = this.alertCtrl.create({
          title: '',
          subTitle: value,
          buttons: ['OK']
        });
        alert.present();
      });
    }
  }

}


@Component({
  templateUrl: 'build/pages/search/searchDetail.html',
  pipes: [TranslatePipe]
})
class SearchDetailPage {
  salida: string;
  destino: string;
  precio: string;
  viajes: boolean;
  horas: FirebaseListObservable<any[]>;
  
  constructor(@Inject(FirebaseRef) public ref: Firebase, public af: AngularFire, public params: NavParams, public viewCtrl: ViewController) {
    let idDestino: string = params.get('idDestino');
    let idSalida: string = params.get('idSalida');
    let fecha = moment(params.get('fecha'));
    let desc: boolean = params.get('desc');
    let firebaseRef: Firebase = this.ref.child('trayectos').child(idSalida);
    
    // Obtenemos nombre de salida
    firebaseRef.on('value', snapshot => {
      this.salida = snapshot.val().salida;
    });
    
    // Obtenemos nombre del destino y precio
    firebaseRef.child('destinos').child(idDestino).on('value', snapshot => {
      this.destino = snapshot.val().destino;
      this.precio = snapshot.val().precio;
    });
    
    // Aplicamos descuento
    if (desc) {
      this.precio = (parseFloat(this.precio)/2).toFixed(2);
    } else {
      this.precio = (parseFloat(this.precio)).toFixed(2);
    }
    
    // Obtenemos fecha
    if (fecha.day() == 6) {
      this.horas = this.af.database.list('/trayectos/' + idSalida + '/destinos/' + idDestino + '/dias/1/sabado');
    } else if (fecha.day() == 0) {
      this.horas = this.af.database.list('/trayectos/' + idSalida + '/destinos/' + idDestino + '/dias/2/domingo');
    } else {
      this.horas = this.af.database.list('/trayectos/' + idSalida + '/destinos/' + idDestino + '/dias/0/lmxjv');
    }

    this.horas.do(snapshots => {
      if (snapshots.length == 0) {
        this.viajes = false;
      } else {
        this.viajes = true;
      }
    }).subscribe();
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }
}